module.exports = __webpack_public_path__ + "static/media/cart.77a2af4c.svg";